import React from "react"
import strings from "../../../localization/strings"
import EditIcon from "material-ui/svg-icons/image/edit"
import DeleteIcon from "material-ui/svg-icons/action/delete"
import { FontIcon } from "material-ui"
import { ITimeoffRequestDocument, ETimeoffStatus } from "../../../models"
interface IProps {
  popupX: number
  popupY: number
  payload: ITimeoffRequestDocument
  editPermission: boolean
  deletePermission: boolean
  updateStatusPermisson: boolean
  handleUpdate(payload: ITimeoffRequestDocument): void
  handleUpdateLeaveRequestStatus(status: ETimeoffStatus, leaveRequest: ITimeoffRequestDocument): void
  handleNotesDrawer(payloadId: string): void
  handleDelete(payload: ITimeoffRequestDocument): void
}

const LeaveTrackingCalendarViewPopup: React.SFC<IProps> = (props: IProps) => {
  return (
    <div
      style={{
        position: "fixed", top: props.popupY, left: props.popupX, backgroundColor: "white", color: "rgba(97, 97, 97, 0.8)",
        boxShadow: "1px 1px 5px rgba(224, 224, 224, 0.5)", width: 110, zIndex: 1000, cursor: "default"
      }}
    >
      {props.editPermission && props.payload.Status === ETimeoffStatus.Requested &&
        <div
          style={{ borderBottom: "1px solid rgb(224, 224, 224)", paddingTop: 10, paddingBottom: 7, display: "flex" }}
          onClick={e => {
            e.stopPropagation()
            props.handleUpdate(props.payload)
          }}
        >
          <div><EditIcon style={{ height: 17, width: 17, marginLeft: 10, marginRight: 10 }} /></div>
          <div>{strings.Edit}</div>
        </div>
      }
      {props.updateStatusPermisson && props.payload.Status === ETimeoffStatus.Requested && [
        <div
          key="approve"
          style={{ borderBottom: "1px solid rgb(224, 224, 224)", paddingTop: 10, paddingBottom: 7, display: "flex" }}
          onClick={e => {
            e.stopPropagation()
            props.handleUpdateLeaveRequestStatus(ETimeoffStatus.Approved, props.payload)
          }}
        >
          <div><FontIcon className="fa fa-check" style={{ fontSize: 17, marginLeft: 10, marginRight: 10 }} /></div>
          <div>{strings.Approve}</div>
        </div>,
        <div
          key="deny"
          style={{ borderBottom: "1px solid rgb(224, 224, 224)", paddingTop: 10, paddingBottom: 7, display: "flex" }}
          onClick={e => {
            e.stopPropagation()
            props.handleUpdateLeaveRequestStatus(ETimeoffStatus.Denied, props.payload)
          }}
        >
          <div><FontIcon className="fa fa-remove" style={{ fontSize: 19, marginLeft: 10, marginRight: 12 }} /></div>
          <div>{strings.Deny}</div>
        </div>
      ]}
      <div
        style={{ borderBottom: "1px solid rgb(224, 224, 224)", paddingTop: 10, paddingBottom: 7, display: "flex" }}
        onClick={e => {
          e.stopPropagation()
          props.handleNotesDrawer(props.payload.Id)
        }}
      >
        <div><FontIcon className="fa fa-comments" style={{ fontSize: 17, marginLeft: 10, marginRight: 10 }} /></div>
        <div>{strings.Note}</div>
      </div>
      {props.deletePermission &&
        <div
          style={{ paddingTop: 10, paddingBottom: 7, display: "flex" }}
          onClick={e => {
            e.stopPropagation()
            props.handleDelete(props.payload)
          }}
        >
          <div><DeleteIcon style={{ height: 17, width: 17, marginLeft: 10, marginRight: 10 }} /></div>
          <div>{strings.Remove}</div>
        </div>
      }
    </div>
  )
}

export default LeaveTrackingCalendarViewPopup